<template>
    <div class="div-menu">
      <ul class="main-menu" v-click-outside="closeAllSubMenus">
        <li class="main-menu-item" :class="{ mainborder: showsubmenu.kits }" @mouseover="openSubMenu('kits')" 
        @mouseleave="closeSubMenu('kits')">
          <span>TEST KITS</span>
          <ul v-if="showsubmenu.kits" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(0,'Management','Test Kits')">Management</li>
            <li class="sub-menu-item" @click="navigate(4,'Outliers','Kits')">Outliers</li>
            <!-- <li class="sub-menu-item" @click="navigate(12,'Import Kits','Kits')">Import Kits</li> -->
            <li class="sub-menu-item" @click="navigate(19,'Import WS Kits','Kits')">Import WS Kits</li>
            <li class="sub-menu-item" @click="navigate(20,'WS Kits','Kits')">WS Kits</li>
            <li class="sub-menu-item" @click="navigate(13,'Import Kits','Kits')">Import Kits</li>
            <li class="sub-menu-item" @click="navigate(15,'Inactive Kits','Kits')">Inactive Kits</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ mainborder: showsubmenu.user }" @mouseover="openSubMenu('user')" 
        @mouseleave="closeSubMenu('user')">
          <span>USER</span>
          <ul v-if="showsubmenu.user" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(1,'Admins','User')">Admins</li>
            <li class="sub-menu-item" @click="navigate(2, 'Lab Operators','User')">Lab Operators</li>
            <li class="sub-menu-item" @click="navigate(22, 'MCT Users','User')">MCT Users</li>
            <li class="sub-menu-item" @click="navigate(8, 'Customers','User')" >Customers</li>
            <li class="sub-menu-item" @click="navigate(20, 'User Logs','User')" >User Logs</li>
          </ul>
        </li>
  
        <li class="main-menu-item" :class="{ mainborder: showsubmenu.inventory }" @mouseover="openSubMenu('inventory')" 
        @mouseleave="closeSubMenu('inventory')">
          <span>INVENTORY</span>
          <ul v-if="showsubmenu.inventory" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(14,'Kit Generation','Inventory')">Kit Generation</li>
            <li class="sub-menu-item" @click="navigate(18, 'Items','Inventory')">Items</li>
            <li class="sub-menu-item" @click="navigate(16,'Amazon','Inventory')" >Amazon</li>
          </ul>
        </li>
  
        <li class="main-menu-item" :class="{ mainborder: showsubmenu.order }" @mouseover="openSubMenu('order')" 
        @mouseleave="closeSubMenu('order')">
          <span>REPORTS</span>
          <ul v-if="showsubmenu.order" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(11,'Woo Orders (Processing)','Reports')">Woo Orders</li>
            <!-- <li class="sub-menu-item" @click="navigate(5,'Reports')">Reports</li> -->
            <li class="sub-menu-item" @click="navigate(17,'Sales','Reports')">Sales</li>
          </ul>
        </li>
  
        <li class="main-menu-item" :class="{ mainborder: showsubmenu.automation }" @mouseover="openSubMenu('automation')" 
        @mouseleave="closeSubMenu('automation')">
          <span>AUTOMATION</span>
          <ul v-if="showsubmenu.automation" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(10,'Job Logs','Automation')">Job Logs</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ mainborder: showsubmenu.tool }" @mouseover="openSubMenu('tool')" 
        @mouseleave="closeSubMenu('tool')">
          <span>TOOLS</span>
          <ul v-if="showsubmenu.tool" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(6,'QR Generator','Tools')">QR Generator</li>
            <li class="sub-menu-item" @click="navigate(7,'URL Generator','Tools')">URL Generator</li>
          </ul>
        </li>
        <li class="main-menu-item" :class="{ mainborder: showsubmenu.others }" @mouseover="openSubMenu('others')" 
        @mouseleave="closeSubMenu('others')">
          <span>OTHERS</span>
          <ul v-if="showsubmenu.others" class="sub-menu">
            <li class="sub-menu-item" @click="navigate(3,'Research','Others')">Research</li>
            <li class="sub-menu-item" @click="navigate(9,'Federal Holidays','Others')">Federal Holidays</li>
          </ul>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
import Breadcrumb from "../dashboard/breadcrumb/Breadcrumb.vue";
  export default {
    name: "HeaderMenu",
    data() {
      return {
        showsubmenu: {
          user: false,
          order:false,
          inventory:false,
          kits:false,
          automation:false,
          tool:false,
          others:false
        },
      };
    },
    methods: {
        ...mapActions([
        "setStatusFilter", 
        "setOverDueByShipped",
        "getAdminInfoList", 
        "setAdminPginationPage", 
        "getLabOperatorInfoList", 
        "sendSearchReqAnalytics", 
        "setAnalyticsHead", 
        "getPendingInfoList", 
        "getAverageReportResultList",
        "getContactCustomers",
        "setCustomerCount",
        "getFederalHolidays",
        "getScheduledJoblogs",
        "getWooOrders",
        "setLoader",
        "resetState",
        "setViewReport",
        "setInventory",
        "setLocations",
        "setPagination", 
        "setFillocation",
        "setFilItem",
        "setItems",
        "setPage",
        "setInvKits",
        "getInactiveList",
        "setAmazonFbaInv",
        "setSalesData",
        "setWooSalesData",
        "setShowinvkit",
        "getMtcLabUserInfoList"
      ]),
      toggleSubMenu(menu) {
        for (let key in this.showsubmenu) {
          if (key !== menu) {
            this.showsubmenu[key] = false;
          }
        }
        // Toggle the submenu visibility based on the clicked menu item
        this.showsubmenu[menu] = !this.showsubmenu[menu];
      },
      closeAllSubMenus(){
        for (let key in this.showsubmenu) {
          this.showsubmenu[key] = false;
        }
      },
      openSubMenu(menu) {
        Object.keys(this.showsubmenu).forEach((key) => {
          this.showsubmenu[key] = key === menu;
        });
      },
      closeSubMenu(menu) {
        this.showsubmenu[menu] = false;
      },
      navigate(val,label,main_label) {
        for (let key in this.showsubmenu) {
          this.showsubmenu[key] = false;
        }
        this.resetState();
        let show_state = false;
        if(val == 0 || val == 4) {
          show_state = true;
        }
        this.$eventBus.$emit("breadcrums",{path: [ { text: main_label, link: "/dashboard" },
                                            { text: label}], show: show_state})
      
        if (val === 0) {
            this.setStatusFilter([]);
            this.getAdminInfoList("kits").then(res => {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
            this.$eventBus.$emit("showoutlinerfilters", { showfilter: true ,value: val});  
        } else if (val === 1) {
            this.setAdminPginationPage(null).then(() => {
            this.getAdminInfoList("admins").then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
            });
        } else  if (val === 2) {
            this.setAdminPginationPage(null).then(() => {
            this.getLabOperatorInfoList("labOps").then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
            });
        } else if (val === 22) {
            this.setAdminPginationPage(null).then(() => {
                this.getMtcLabUserInfoList("mtcLab").then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val, label: label });
                });
            });
        }  else  if (val === 3) {
            this.sendSearchReqAnalytics().then(res => {
                this.setAnalyticsHead({status:3,type:null,show:false,item:null,count:null,total:null});
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
        }  else  if (val === 4) {
            this.setOverDueByShipped(null);
            this.getPendingInfoList("pending").then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
                });
        }  else if (val === 5) {
          this.setAdminPginationPage(null).then(() => {
          this.getAverageReportResultList("avg").then(res => {
             this.$eventBus.$emit("title", { show: false, value: val , label: label});
          });
          });
        }  else  if (val === 6) {
              this.$eventBus.$emit("title", { show: false, value: val , label: label});
        }  else if (val === 7) {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 8) {
            this.setAdminPginationPage(null).then(() => {
                this.setCustomerCount(0).then(() => {
                this.getContactCustomers(null).then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val , label: label});
                });
                });
            });
        } else  if (val === 9) {
            this.getFederalHolidays().then(res => {
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
        } else  if (val === 10) {
          this.getScheduledJoblogs().then(res => {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
          });
        } else  if (val === 11) {
            this.setLoader(true);
            this.getWooOrders().then(async res => {
                this.setLoader(false);
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
            });
        } else  if (val === 12) {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 13 || val === 19 || val === 20) {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 20) {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 14) {
            this.setLoader(true);
            this.setLocations();
            this.setItems();
            this.setFillocation('');
            this.setFilItem('');
            this.setInvKits(false);
            this.setPage(1).then(() => {
              this.setInventory().then(async res => {
                this.setLoader(false);
                this.$eventBus.$emit("title", { show: false, value: val , label: label});
                this.setShowinvkit(true);
              });
            });
        } else  if (val === 15) {
          this.getInactiveList("kits").then(res => {
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
          });
        }  else  if (val === 16) {
          this.setAmazonFbaInv();
          this.$eventBus.$emit("title", { show: false, value: val , label: label});
        } else  if (val === 17) {
            this.setSalesData();
            this.setWooSalesData();
            this.$eventBus.$emit("title", { show: false, value: val , label: label});
        }  else  if (val === 18) {
          this.setLoader(true);
            this.setLocations();
            this.setItems();
            this.setFillocation('');
            this.setFilItem('');
            this.setInvKits(false);
            this.setPage(1).then(() => {
              this.setInventory().then(async res => {
                this.setLoader(false);
                this.$eventBus.$emit("title", { show: false, value: 14 });
                this.setShowinvkit(false);
              });
            });
        } 
      }
    },
  };
  </script>
  
  <style scoped>
.div-menu {
  background-color: #fff;
 
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.main-menu {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  color: #6B6B6B;
  gap: 15px; 
}
.main-menu-item span {
  font-family: TTNormsMedium,sans-serif;
  white-space: nowrap;
}
.main-menu-item {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.3s ease;
}

.main-menu-item:hover {
  background-color: #f5f5f5;
}

.sub-menu {
  position: absolute;
  top: 20px;
  background-color: #fff;
  color: #005EB8;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  list-style: none;
  left:0;
  width:180px;
}

.sub-menu-item {
  padding: 8px 12px;
  cursor: pointer;
}

.sub-menu-item:hover {
  background-color: #eee;
}

.toggle-icon {
  height: 14px;
  margin-left: 10px;
  transition: transform 0.3s ease;
}

.rotated {
  transform: rotate(180deg);
}

.mainborder {
  border-bottom: 1px solid #005EB8;
  color: #005EB8;
}

  </style>
  